import * as React from 'react'
import {
  createFileRoute,
  useLoaderData,
} from '@tanstack/react-router'
import { createUserQueryOptions } from '@/services/auth/auth.options'
import { queryClient } from '@/lib/queryClient'
import UserProfile from '@/pages/userProfile/UserProfile.page'
import { createPermissionsQueryOptions } from '@/services/rolesPermissions/rolesPermission.options'
import { Header } from '@/layouts/layout-core-v6'
import { Typography } from '@mui/material'

export const Route = createFileRoute('/_auth/user-profile')({
  beforeLoad: async ({ context: { queryClient, auth } }) => {
    const permissions = queryClient.ensureQueryData(createPermissionsQueryOptions(auth.checkAuthStatus))
    return { permissions }
  },
  component: () => {
    return (
      <>
        <Header>
          <Typography variant="h6" sx={{ ml: 4 }}>User Profile</Typography>
        </Header>
        <UserProfile />
      </>
    )
  },
})

const UserProfileLayout = () => {

  return (
    <>
      <UserProfile />
    </>
  )
}
